import { Component, h, Method, State, Host } from '@stencil/core';

@Component({
	tag: 'ds-loading-spinner',
	shadow: false,
})
export class LoadingSpinner {
	@State() fadingOut = false;
	@State() hidden = false;

	timer;

	@Method()
	async show() {
		this.hidden = false;
		this.fadingOut = false;
	}

	@Method()
	async hide() {
		return new Promise((resolve) => {
			this.fadingOut = true;

			if (this.timer) {
				clearTimeout(this.timer);
			}
			this.timer = setTimeout(() => {
				this.hidden = true;
				resolve(true);
			}, 400);
		});
	}

	getClasses() {
		const classes = [];
		if (this.hidden) {
			classes.push('ds-hidden');
		}
		if (this.fadingOut) {
			classes.push('ds-fading-out');
		}

		return classes.join(' ');
	}

	render() {
		return (
			<Host class={this.getClasses()}>
				<div class="ds-quarter-circle"></div>
				<div class="ds-quarter-circle"></div>
				<div class="ds-quarter-circle"></div>
				<div class="ds-quarter-circle"></div>
			</Host>
		);
	}
}
